import { Card, message, Modal, Select, Typography } from 'antd';
import { requestform } from 'messages';
import React, { useState } from 'react';
import { usePatchAssignEmployeeMutation } from '../../../services';
import { AssignEmployeeTicketRequest } from '../../../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { GetUserListInOrganization } from '../../../hooks/request-form';
import progressIcon from '../../../assets/svg/progressing-setting.svg';

interface ObstacleTickets {
  ticketId: number;
  closeAssignModal: () => void;

  onActionSuccess?: () => void;
}

const ModalAssignEmployee: React.FC<ObstacleTickets> = ({ ticketId, closeAssignModal, onActionSuccess }) => {
  const profile = useSelector((state: RootState) => state.users.userProfile);
  const { userInUnitList } = GetUserListInOrganization(profile?.organizationUnitId ? profile?.organizationUnitId : 0);

  const [assignUserInUnit, setAssignUserInUnit] = useState<number>(0);
  const [assigneeEmployee] = usePatchAssignEmployeeMutation();
  const assignEmployee = () => {
    if (assignUserInUnit == 0) {
      message.error('Chọn nhân viên tiếp nhận');
      return;
    }

    const assigneeData: AssignEmployeeTicketRequest = {
      assigneeId: assignUserInUnit,
      ticketId
    };

    Modal.confirm({
      title: 'Xác nhận giao phiếu',
      okText: 'Tiếp nhận',
      cancelText: 'Hủy',
      onOk() {
        assigneeEmployee(assigneeData)
          .unwrap()
          .then(() => {
            message.success('Giao phiếu thành công');
            closeAssignModal();
            onActionSuccess && onActionSuccess();
          });
      }
    });
  };

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.assignTicketTitle}
        </Typography.Text>
      }
      className='space-y-4 bg-[#F5F5F7] text-center'
    >
      <div className='flex items-center space-x-3'>
        <img src={progressIcon} alt='' />
        <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
          {requestform.assignEmployeeTitle}
        </Typography.Text>
      </div>

      <div className='flex w-full items-center space-x-3 pb-5'>
        <div className='w-1/5'>
          <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>{requestform.employee}</Typography.Text>
        </div>

        <Select
          className='w-full'
          defaultValue={0}
          style={{ width: 200 }}
          onChange={(value) => setAssignUserInUnit && setAssignUserInUnit(value)}
          options={[
            { value: 0, label: 'Chọn nhân viên' },
            ...userInUnitList
              .filter((user) => user.userId !== profile?.userId)
              .map((user) => ({
                value: user.userId,
                label: user.fullName
              }))
          ]}
        />
      </div>

      <div className='flex justify-end'>
        <button
          onClick={assignEmployee}
          className='rounded-lg bg-[#28A745] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
        >
          {requestform.confirmAssignEmployee}
        </button>
      </div>
    </Card>
  );
};

export default ModalAssignEmployee;
